export const SET_COUNTRIES = 'SetCountries'
